import request from '@/utils/request'

// 查询短信套餐配置分页
export function fetchList(query) {
  return request({
    url: '/extra/sms/plan/page',
    method: 'get',
    params: query,
  })
}

// 获取单个短信套餐
export function getObj(id) {
  return request({
    url: '/extra/sms/plan/detail?id=' + id,
    method: 'get',
  })
}

// 新增短信套餐
export function addObj(data) {
  return request({
    url: '/extra/sms/plan/add',
    method: 'post',
    data: data,
  })
}

// 修改短信套餐
export function putObj(data) {
  return request({
    url: '/extra/sms/plan/edit',
    method: 'post',
    data: data,
  })
}

// 编辑短信套餐状态
export function editStatus(data) {
  return request({
    url: '/extra/sms/plan/enable',
    method: 'post',
    data: data,
  })
}

// 删除短信套餐
export function delObj(data) {
  return request({
    url: '/extra/sms/plan/delete',
    method: 'post',
    data: data,
  })
}
